<template>
  <OverlayDialogue
    name="overlay-newsletter"
    class="overlay-dialogue--newsletter"
    :path-blacklist="['/collections/nailpolish']"
    :title="title"
  >
    <NewsletterOld :note="note" :image="image" />
  </OverlayDialogue>
</template>

<script lang="ts" setup>
import { useAppInject } from '../../context/useAppContext'
import NewsletterOld from '../newsletter/NewsletterOld.vue'
import OverlayDialogue from './OverlayDialogue.vue'

const { shop } = useAppInject()
const newsletter = shop.metafields.newsletter as any
const title = newsletter.title
const note = newsletter.note
const image = newsletter.image[0]
</script>

<style lang="scss">
@import '~styles/base.scss';

/* Newsletter-specific overrides */
.overlay-dialogue--newsletter {
  /* put it in the bottom-left */
  top: auto !important;
  right: auto !important;
  bottom: 6px;
  left: 6px;

  /* shrink the overall box */
  width: 300px; /* was 400px */
  @include media('s') {
    width: calc(100vw - 2 * var(--pop-up-offset, 16px));
    max-width: 300px;
  }

  /* tighten inner padding and ensure everything fits the smaller box */
  .overlay-dialogue__inner {
    padding: 8px;
  }

  .overlay-dialogue__title {
    @include type-xxs-uppercase;
    margin-bottom: 8px;
  }

  /* Make form + image fluid to the container width */
  .newsletter,
  .newsletter-footer {
    max-width: 100%;
  }

  .newsletter__note {
    @include type-xs;
    margin-bottom: 12px;
  }

  .newsletter__form,
  .newsletter-footer__form {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 8px;
  }

  .newsletter__email,
  .newsletter-footer__input {
    width: 100%;
    min-width: 0; /* allow shrinking inside grid */
  }

  .newsletter__submit,
  .newsletter-footer__submit {
    white-space: nowrap;
    padding: 6px 10px 4px;
  }

  /* Make the image obey the smaller box */
  img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
    margin-top: 8px;
    aspect-ratio: 5/6;
  }
}
</style>
